import { render, staticRenderFns } from "./Profile_Password.vue?vue&type=template&id=3ffc4dce&scoped=true&"
import script from "./Profile_Password.vue?vue&type=script&lang=js&"
export * from "./Profile_Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc4dce",
  null
  
)

export default component.exports